<template>
  <div
    class="projects clearfix"
    :class="{ 'no-landscape': !landscapeLightBoxProjects.length }"
    @mouseleave="onMouseLeave"
    >
    <lightbox
      v-for="(lightboxProject, index) in landscapeLightBoxProjects"
      :uid="lightboxProject.uid"
      :key="'llb-' + index"
      :class="{ 'hidden': hiddens[`llb-${index}`] }"
      @mouseenter="onMouseEnterLightbox($event, 'llb-' + index)"
      @click="onClickLightbox"
      ></lightbox>
    <lightbox
      v-for="(lightboxProject, index) in portraitLightBoxProjects"
      :seq="index"
      :uid="lightboxProject.uid"
      :key="'plb-' + index"
      :class="{ 'hidden': hiddens[`plb-${index}`] }"
      :projects="portraitProjectsRandomized"
      @mouseenter="onMouseEnterLightbox($event, 'plb-' + index)"
      @project-changed="onProjectChanged"
      @click="onClickLightbox"
      ></lightbox>
    <div class="lightbox-preloader">
      <!-- NOTE: just load one file here to lessen the load on desktop -->
      <template v-for="preloadedLightboxProject in preloadedLightboxProjects">
        <img v-for="file in preloadedLightboxProject.files" :key="file.url" :src="file.url">
      </template>
    </div>
  </div>
</template>

<script>
import Lightbox from './Lightbox'

export default {
  name: 'projects',
  components: {
    'lightbox': Lightbox
  },
  computed: {
    subpages () {
      return this.$store.getters.getPagesByType('Project')
    },
    page () {
      return this.$store.getters.getPagesByType('Projects')[0]
    },
    phone () {
      return this.$store.state.app.phone
    }
  },
  data () {
    return {
      numLandscapeBuckets: 0,
      numPortraitBuckets: 3,
      portraitProjectsRandomized: [],
      landscapeProjectsRandomized: [],
      landscapeLightBoxProjects: [],
      portraitLightBoxProjects: [],
      interval: 3000,
      timeout: null,
      preloadedLightboxProjects: [],
      hiddens: {}
    }
  },
  created () {
    this.buildLandscapeProjectsRandomized()
    this.buildPortraitProjectsRandomized()

    if (this.landscapeProjectsRandomized.length) {
      this.numLandscapeBuckets = 1
      this.numPortraitBuckets = 1
    }

    this.selectPortraitLightboxProjects()
    this.selectLandscapeLightboxProjects()

    for (let i = 0; i < this.landscapeLightBoxProjects.length; i++) {
      this.$set(this.hiddens, 'llb-' + i, false)
    }

    for (let i = 0; i < this.portraitLightBoxProjects.length; i++) {
      this.$set(this.hiddens, 'plb-' + i, false)
    }
  },
  mounted () {
    // NB: don't rotate projects on phone
    if (this.phone) {
      return
    }

    this.setProjectRotation()
  },
  watch: {
    phone (newValue, oldValue) {
      if (!newValue) {
        this.setProjectRotation()
      } else {
        this.cancelProjectRotation()
      }
    }
  },
  methods: {
    onProjectChanged({ project }) {
      // preload given project files on phone
      if (project && this.phone) {
        this.preloadedLightboxProjects = [project]
      }
    },
    setProjectRotation () {
      this.timeout = window.setTimeout(() => {
        this.rotateProjects()
      }, this.interval)
    },
    cancelProjectRotation () {
      window.clearTimeout(this.timeout)
      this.timeout = null
    },
    rotateProjects () {
      this.preloadedLightboxProjects = []
      this.selectPortraitLightboxProjects()
      this.selectLandscapeLightboxProjects()

      this.setProjectRotation()
    },
    onMouseLeave (event, lkey) {
      for (const key in this.hiddens) {
        this.$set(this.hiddens, key, false)
      }

      this.setProjectRotation()
    },
    onMouseEnterLightbox (event, lkey) {
      // NB: don't stop slideshow on mobile
      if (this.phone) {
        return
      }

      this.cancelProjectRotation()

      for (const key in this.hiddens) {
        if (key === lkey) {
          this.$set(this.hiddens, key, false)
        } else {
          this.$set(this.hiddens, key, true)
        }
      }
    },
    onClickLightbox (event) {
      // TODO?
      // this.cancelProjectRotation()
      // this.setProjectRotation()
    },
    shuffle (a) {
      var j, x, i
      for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1))
        x = a[i]
        a[i] = a[j]
        a[j] = x
      }
    },
    buildLandscapeProjectsRandomized () {
      let subpages = this.subpages.filter(subpage => subpage.content.landscape === '1' || subpage.content.landscape === 'true').slice()
      this.shuffle(subpages)
      this.landscapeProjectsRandomized = subpages
    },
    selectLandscapeLightboxProjects () {
      this.selectLightboxProjects('landscapeProjectsRandomized', 'landscapeLightBoxProjects', this.numLandscapeBuckets, this.buildLandscapeProjectsRandomized)
    },
    buildPortraitProjectsRandomized () {
      let subpages = this.subpages.filter(subpage => subpage.content.landscape === '0' || !subpage.content.landscape || subpage.content.landscape === 'false').slice()
      this.shuffle(subpages)
      this.portraitProjectsRandomized = subpages
    },
    selectPortraitLightboxProjects () {
      this.selectLightboxProjects('portraitProjectsRandomized', 'portraitLightBoxProjects', this.numPortraitBuckets, this.buildPortraitProjectsRandomized)
    },
    selectLightboxProjects (sourceCollection, targetCollection, numBuckets, buildFunction) {
      // FIXME don't let it be possible for the next project after building to be the same
      // as the one before
      let tmpCollection = []
      if (!this[sourceCollection].length) {
        this[targetCollection] = tmpCollection
      }

      let i = numBuckets
      while (i--) {
        let project = this[sourceCollection].pop()
        tmpCollection.push(project)
      }

      this[targetCollection] = tmpCollection
      this.preloadLightboxProjects(sourceCollection, numBuckets, buildFunction)
    },
    preloadLightboxProjects (sourceCollection, numBuckets, buildFunction) {
      if (this[sourceCollection].length < numBuckets) {
        buildFunction()
      }

      let i = this[sourceCollection].length - 1
      while (this[sourceCollection].length - i <= numBuckets) {
        let project = this[sourceCollection][i]
        this.preloadedLightboxProjects.push(project)
        i--
      }
    },
    getLandscapeKey (index) {
      return 'llb-' + index
    },
    getPortraitKey (index) {
      return 'plb-' + index
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';

.projects {
  margin-left: #{$body-padding * -1};
  margin-bottom: 1rem;

  .lightbox-preloader {
    width: 1px;
    height: 1px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// client/components/Projects.vue